import React from "react";
import "./styles/ActiveFilterChip.css";

/**
 * ActiveFilterChipList - Displays active filters with clear buttons
 * @param {Object} props
 * @param {Array} props.filters - Array of { id, label }
 * @param {Function} props.onClearFilter - Handler to clear individual filter
 * @param {Function} props.onClearAll - Handler to clear all filters
 * @param {boolean} props.showLabel - Show the leading "Filters" label
 */
const ActiveFilterChipList = ({
  filters,
  onClearFilter,
  onClearAll,
  showLabel = true,
}) => {
  if (!filters || filters.length === 0) return null;

  return (
    <div className="activeFilters">
      {showLabel && <span className="activeFiltersLabel">Filters</span>}
      {filters.map((filter) => (
        <div key={filter.id} className="filterChip">
          <span className="chipLabel" title={filter.label}>
            {filter.label}
          </span>
          <button
            type="button"
            className="chipClose"
            onClick={() => onClearFilter(filter.id)}
            aria-label={`Clear ${filter.label} filter`}
          >
            ✕
          </button>
        </div>
      ))}
      {filters.length > 1 && (
        <button
          type="button"
          className="clearAllButton"
          onClick={onClearAll}
          aria-label="Clear all filters"
        >
          Clear all
        </button>
      )}
    </div>
  );
};

export default ActiveFilterChipList;
